module.exports = __webpack_public_path__ + "img/precipitacion_a25.ae569dbb.png";